<template>
  <Toast />
  <Message v-if="!service_enabled" severity="warn">Mail service is disabled for this domain</Message>
  <Breadcrumb :home="bc_home" :model="bc_items" />
  <MailNavBar />

  <Panel header="Mail Settings" class="p-mt-3">
    <h6>TBD</h6>
  </Panel>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import MailNavBar from '../components/MailNavBar.vue'

export default {
  name: 'MailSettings',
  components: {
    MailNavBar,
  },
  data () {
    return {
      errors: {},
      loading: false,
      domain: {id: null, name: "", services: [], attributes: []},
      loading: false,
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Settings'}
      ],
      service_enabled: true,
    }
  },
  computed: {
    ...mapGetters({ MailAccounts: 'StateMailAccounts', Domains: 'StateDomains', GetDomain: 'GetDomain' }),
  },
  watch: {
    current_domain (d) {
      console.log(d)
      if (d.domain && d.domain.name.length) {
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Settings'}
        ]

        const services = getAttributes(d.domain.attributes, 'services')

        if (services && services.mail && services.mail.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      }
    },
  },
  created: function () {
    this.GetDomain(this.$route.params.domain_id)
      .then(response => {
        this.domain = response
        this.domain_name = this.domain
        this.bc_items = [
          {label: this.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Settings'}
        ]

        const services = getAttributes(this.domain.attributes, 'services')

        if (services && services.mail && services.mail.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      })
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
